var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',[_vm._v("This is a home page")])])}
var staticRenderFns = []

export { render, staticRenderFns }